import { AttendanceApprovalSettingCard } from "./AttendanceApprovalSettingCard.js";
import { AttendancePolicyCard } from "./AttendancePolicyCard.js";
import AttendanceAlertsPanel from "../pages/admin/AttendanceAlertsPanel.js";

/**
 * Everything the super HR admin controls about attendance, in one tab: the approval
 * workflow switch, the missed check-out policy and the alert rules. Kept as its own
 * component so AdminPage stays a dispatcher rather than growing another screen inline.
 */
export function AttendanceAdminPanel() {
  return (
    <div className="flex flex-col gap-5">
      <AttendanceApprovalSettingCard />
      <AttendancePolicyCard />
      <AttendanceAlertsPanel />
    </div>
  );
}
